import { render, staticRenderFns } from "./table-cell-widget.vue?vue&type=template&id=66f5c5d1&scoped=true&"
import script from "./table-cell-widget.vue?vue&type=script&lang=js&"
export * from "./table-cell-widget.vue?vue&type=script&lang=js&"
import style0 from "./table-cell-widget.vue?vue&type=style&index=0&id=66f5c5d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f5c5d1",
  null
  
)

export default component.exports